import sessionStorage from '~/services/storage/sessionStorage';

// Survives the OAuth / magic-link redirect, which a redux flag cannot.
const JUST_AUTHENTICATED_KEY = 'just-authenticated';

const PENDING = 'pending';
const CLAIMED = 'claimed';

export const markJustAuthenticated = (): void => {
  sessionStorage.setByKey(JUST_AUTHENTICATED_KEY, PENDING);
};

export const isJustAuthenticated = (): boolean =>
  sessionStorage.getByKey(JUST_AUTHENTICATED_KEY) !== null;

/**
 * Takes ownership of the post-auth surface for this sign-in. Returns false when
 * somebody already took it. The signal itself stays set on purpose: it is only
 * dropped once the surface actually rendered, so a failed one still gates.
 */
export const claimJustAuthenticated = (): boolean => {
  if (sessionStorage.getByKey(JUST_AUTHENTICATED_KEY) !== PENDING) {
    return false;
  }
  sessionStorage.setByKey(JUST_AUTHENTICATED_KEY, CLAIMED);
  return true;
};

export const clearJustAuthenticated = (): void => {
  sessionStorage.removeByKey(JUST_AUTHENTICATED_KEY);
};
